module.exports = __webpack_public_path__ + "static/media/icon_arrow_gray_right.2fbac53b.svg";